import React from "react";
import "./Input.scss";

interface Props {
  label?: string;
  placeholder?: string;
  value: string;
  type: string;
  id: string;
  onChange: (e: string) => void;
  hasError?: boolean;
  disabled?: boolean;
  icon?: string;
  iconPosition?: "left" | "right";
  onIconClick?: () => void;
  name?: string;
  autoComplete?: string;
  onAutoFill?: (value: string) => void;
}

const Input: React.FC<Props> = ({
  label,
  placeholder,
  value,
  type,
  id,
  onChange,
  disabled,
  hasError,
  icon,
  iconPosition = "right",
  onIconClick,
  name,
  autoComplete,
  onAutoFill,
}) => {
  return (
    <div
      className={`
        input
        ${hasError ? "input--error" : ""}
        ${disabled ? "input--disabled" : ""}
      `}
    >
      {label && (
        <label htmlFor={id} className="input__label">
          {label}
        </label>
      )}

      <div className="input__field-wrapper">
        {icon && iconPosition === "left" && (
          <button
            type="button"
            className="input__icon input__icon--left"
            onClick={onIconClick}
          >
            <img src={icon} alt="" />
          </button>
        )}

        <input
          id={id}
          name={name}
          type={type}
          value={value}
          disabled={disabled}
          autoComplete={autoComplete}
          placeholder={placeholder ?? ""}
          className={`
      input__field
      ${icon ? `input__field--${iconPosition}` : ""}
    `}
          onChange={(e) => onChange(e.target.value)}
          onAnimationStart={(e) => {
            if (e.animationName === "login-autofill-start") {
              onAutoFill?.(e.currentTarget.value);
            }
          }}
        />

        {icon && iconPosition === "right" && (
          <button
            type="button"
            className="input__icon input__icon--right"
            onClick={onIconClick}
          >
            <img src={icon} alt="" />
          </button>
        )}
      </div>
    </div>
  );
};

export default Input;
